import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  declare readonly containerTarget: HTMLElement

  connect() {
    // Prevent body scroll when modal is open
    document.body.style.overflow = "hidden"
  }

  disconnect() {
    // Restore body scroll when modal is closed
    document.body.style.overflow = ""
  }

  close(event: Event) {
    // Close modal when clicking backdrop or close button
    if (event.target === event.currentTarget || (event.target as HTMLElement).closest("[data-action*='confirmation-modal#close']")) {
      this.element.remove()
    }
  }

  closeOnEscape(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.element.remove()
    }
  }
}
